import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import moment from 'moment';
import 'moment/locale/cs';
import {CZECH_MOMENT_LOCALE_SPECIFICATION} from "./app/core/localization/czech-moment-date-adapter"; // Import Czech locale

if (environment.production) {
  enableProdMode();
}

moment.locale('cs');
moment.updateLocale('cs', CZECH_MOMENT_LOCALE_SPECIFICATION);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
